const factorOptions = [
  {
    value: "THERAPIST_BEHAVIOUR",
    label: "Therapist Behaviour",
    image: "/assets/screen3-assets/Theraphy_Behaviour.webp",
  },
  {
    value: "THERAPY_EFFECTIVENESS",
    label: "Therapy Effectiveness",
    image: "/assets/screen3-assets/Theraphy_Effectiveness.webp",
  },
  {
    value: "CARE_ATTENTION",
    label: "Care & Attention",
    image: "/assets/screen3-assets/Care.webp",
  },
  {
    value: "COMFORT",
    label: "Comfort",
    image: "/assets/screen3-assets/Comfort.webp",
  },
  {
    value: "CLEANLINESS",
    label: "Cleanliness",
    image: "/assets/screen3-assets/Cleanliness.webp",
  },
  {
    value: "PRIVACY",
    label: "Privacy",
    image: "/assets/screen3-assets/Privacy.webp",
  },
  {
    value: "AMBIENCE",
    label: "Ambience",
    image: "/assets/screen3-assets/Ambience.webp",
  },
  {
    value: "OTHER",
    label: "Other",
    image: "/assets/screen3-assets/Other.webp",
  },
];

const ratingValues = [1, 2, 3, 4, 5];
const filledStar = "\u2605";
const emptyStar = "\u2606";


const ScreenThree = ({
  rating,
  selectedFactors,
  otherFactor,
  onRatingChange,
  onFactorToggle,
  onOtherFactorChange,
}) => {

  const otherSelected = selectedFactors.includes("OTHER");

  return (
    <section className="screen-three" aria-labelledby="screen-three-title">
      <aside className="screen-three__intro left-side">
        <div className="screen-three__intro-title" aria-hidden="true">
          <strong>Rate Today&rsquo;s</strong>
          <span>Therapy</span>
        </div>
        <img
          className="screen-three__intro-divider"
          src="/assets/screen4-assets/line.webp"
          alt=""
          aria-hidden="true"
        />
        <p>On a scale of 1 to 5</p>
      </aside>

      <div className="content-side">
        <div className="screen-three__main main-content">
        <header className="screen-three__heading">
          <h2 id="screen-three-title">Rate Today&rsquo;s Therapy</h2>
          <p>On a scale of 1 to 5</p>
        </header>

        <fieldset className="therapy-rating">
          <legend className="visually-hidden">Rate today&rsquo;s therapy</legend>
          <div className="therapy-rating__stars">
            {ratingValues.map((value) => (
              <label
                className={`therapy-star${value <= rating ? " is-filled" : ""}`}
                key={value}
              >
                <input
                  type="radio"
                  name="therapy_rating"
                  value={value}
                  checked={rating === value}
                  onChange={() => onRatingChange(value)}
                  aria-label={`${value} ${value === 1 ? "star" : "stars"}`}
                />
                <span aria-hidden="true">
                  {value <= rating ? filledStar : emptyStar}
                </span>
              </label>
            ))}
          </div>
          <p className="therapy-rating__caption" aria-live="polite">
            {rating
              ? "Great! Thank you for your feedback."
              : "Tap a star to rate today’s therapy."}
          </p>
        </fieldset>

        <fieldset className="therapy-factors">
          <legend>What contributed most to your experience?</legend>
          <div className="therapy-factors__grid">
            {factorOptions.map((factor) => {
              const selected = selectedFactors.includes(factor.value);

              return (
                <label
                  className={`therapy-factor${selected ? " is-selected" : ""}`}
                  key={factor.value}
                >
                  <input
                    type="checkbox"
                    name="factors[]"
                    value={factor.value}
                    checked={selected}
                    onChange={() => onFactorToggle(factor.value)}
                  />
                  <img src={factor.image} alt="" aria-hidden="true" />
                  <span>{factor.label}</span>
                  <b className="therapy-factor__check" aria-hidden="true">
                    {selected ? "\u2713" : ""}
                  </b>
                </label>
              );
            })}
          </div>
        </fieldset>

        {otherSelected && (
          <div className="therapy-other-field">
            <label htmlFor="other-factor">
              Please specify <span>(optional)</span>
            </label>
            <input
              id="other-factor"
              name="other_factor"
              type="text"
              placeholder="Add a short note..."
              value={otherFactor}
              onChange={(event) => onOtherFactorChange(event.target.value)}
            />
          </div>
        )}

        <section
          className="therapy-feedback-note"
          aria-label="Your feedback helps us provide healing, inside out."
        >
          <img
            className="therapy-feedback-note__leaf therapy-feedback-note__leaf--left"
            src="/assets/screen1-assets/Leaf_02.webp"
            alt=""
            aria-hidden="true"
          />
          <p>
            Your feedback helps us provide <strong>healing, inside out.</strong>
          </p>
          <img
            className="therapy-feedback-note__leaf therapy-feedback-note__leaf--right"
            src="/assets/screen1-assets/Leaf_01.webp"
            alt=""
            aria-hidden="true"
          />
        </section>
        </div>
      </div>
    </section>
  );
}

export default ScreenThree;
